import {
  ADMIRAL_LUCKY_TRIP_TRAVEL,
  IPolicy
} from '../data/api/models';


export const isLuckyTripProduct = (policy: IPolicy): boolean => {
  if (!policy) {
    return false;
  }
  return policy.productName === ADMIRAL_LUCKY_TRIP_TRAVEL
}
